// Recovered compiled webpack factory 96058. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    Object.defineProperty(t, "addBasePath", {
      enumerable: !0,
      get: function () {
        return o;
      },
    }));
  let n = r(73879),
    a = r(71239);
  function o(e, t) {
    return (0, a.normalizePathTrailingSlash)((0, n.addPathPrefix)(e, ""));
  }
  ("function" == typeof t.default || ("object" == typeof t.default && null !== t.default)) &&
    void 0 === t.default.__esModule &&
    (Object.defineProperty(t.default, "__esModule", { value: !0 }),
    Object.assign(t.default, t),
    (e.exports = t.default));
}
